const context = require.context('./', true, /\.\/[^/]+\/[^/]+\/index\.js$/)

context.keys().forEach((filePath) => {
  const componentName = filePath.replace(/^.+\/([^/]+)\/index\.js/, '$1')
  if (process.env.NODE_ENV === 'development') console.log('%cExporting component: ', 'color:blue', componentName)
  module.exports[componentName] = context(filePath).default
})
